import MainLayout from "components/layout/main-layout/MainLayout";
import { useAdvancedValidation } from "hooks/useAdvancedValidation";
import "./DeviceProfile.css";
import { titles } from "constants/titles";
import CustomButton from "components/widgets/custom-button/CustomButton";
import MessageSnackBar from "components/widgets/message-snackbar/MessageSnackBar";
import {
  ArrowRight,
  IconEdit,
  IconGPSDevice,
  IconQuestion,
  IconTracking,
} from "assets/SVGs/SVGs";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import DeviceInfoModal from "components/layout/device-info-modal/DeviceInfoModal";
import EditDeviceNameModal from "components/layout/edit-device-name-modal/EditDeviceNameModal";
import AddStepGoalModal from "components/layout/add-step-goal-modal/AddStepGoalModal";
import ConfirmationModal from "components/layout/confirmation-modal/ConfirmationModal";
import ChangesSavedModal from "components/layout/changes-saved-modal/ChangesSavedModal";
import RingDeviceModal from "components/layout/ring-device-modal/RingDeviceModal";
import CaregiverTrackingCard from "components/layout/caregiver-tracking-card/CaregiverTrackingCard";
import StepCounterCard from "components/layout/step-counter-card/StepCounterCard";
import {
  convertInRequiredTimeZone,
  getLastRefreshTimeInMinutes,
  getManualRefreshTime,
  getRefreshDisabledMessage,
  getStaticUrlByKey,
  isDisableManualRefresh,
  isEmpty,
} from "utility";
import {
  callHeartBeatForClairvoyantDevice,
  getAneltoDeviceDetail,
  getAneltoDeviceInitialLoadData,
  getAneltoTimeline,
  getClairvoyantDeviceDetail,
  getClairvoyantTimeline,
  getEviewTimeLine,
  getFreeusDeviceDetail,
  getFreeusDeviceInitialLoadData,
  getFreeusTimeline,
  ringMyDevice,
  setDeviceDetailLoaderVisibility,
  updateEviewFunction,
  getEviewDeviceDetail,
} from "redux/Devices/actions";
import { useDispatch, useSelector } from "react-redux";
import { loader_gif, refresh_loop } from "assets/images/images";
import {
  deviceLocationPayload,
  getCalculatedLastRefreshTime,
} from "../../utility/deviceDetailUtils";
import InformationModal from "components/layout/information-modal/InformationModal";
import DeviceSignalCard from "components/layout/device-signal-card/DeviceSignalCard";
import FrequentRequestPopup from "components/layout/frequent-request-popup/FrequentRequestPopup";

const DeviceProfile = () => {
  const [showDeviceInfo, setShowDeviceInfo] = useState(false);
  const [showEditDeviceModal, setShowEditDeviceModal] = useState(false);
  const [showAddStepGoalModal, setShowAddStepGoalModal] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showSavedSuccessModal, setShowSavedSuccessModal] = useState(false);
  const [showRingDeviceModal, setShowRingDeviceModal] = useState(false);
  const [eViewIntervalIndex, setEviewIntervalIndex] = useState(0);
  const [eViewInterval, setEviewInterval] = useState(false);
  const [informationModal, setInformationModal] = useState(false);
  const [frequentRequestPopup, setFrequentRequestPopup] = useState({
    data: null,
    isVisible: false,
  });
  const history = useHistory();

  // Initialize validation hook
  const { onApiResponse, snackbarState, dismissSnackbar } =
    useAdvancedValidation();

  const accordianButtons = [
    {
      name: titles?.device_signal_history,
      onClick: () => history.push(ROUTES_CONSTANTS?.deviceSignalHistory),
    },
    {
      name: titles?.get_user_help_guide,
      onClick: () => onUserHelpGuide(),
    },
  ];

  const [deviceLocation, setDeviceLocation] = useState({
    latitude: 0,
    longitude: 0,
    latitudeDelta: 0.008,
    longitudeDelta: 0.008,
  });

  const [disableManualRefresh, setDisableManualRefresh] = useState(false);
  const [manualRefreshIntervalTime, setManualRefreshIntervalTime] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);

  const userData = useSelector((store) => store?.auth?.userData);
  const {
    aneltoDeviceDetails,
    selectedDeviceDetails,
    freeusDeviceDetails,
    clairvoyantDeviceDetails,
    loading,
    freeusIntervals,
    aneltoIntervals,
    clairvoyantIntervals,
    eViewDeviceDetails,
    deviceDetailLoading,
    eViewIntervalArray,
    manualRefreshLoading,
    deviceRefreshData,
  } = useSelector((store) => store?.devices);
  const { staticUrls, currentTimeZone } = useSelector((store) => store?.common);
  const { selectedMedicalUser } = useSelector(
    (store) => store?.medicalAlertUsers
  );
  const dispatch = useDispatch();
  const isInHomDevice = isEmpty(selectedDeviceDetails?.device_type);

  useEffect(() => {
    if (!isInHomDevice) {
      const param = {
        dispatch,
        userType: userData?.isGuestUser ? "guestuser" : "accountowner",
      };
      getAneltoTimeline(param);
      getFreeusTimeline(param);
      getClairvoyantTimeline(param);
      getEviewTimeLine(param);
      getDeviceProfileDetail(true);
    }
    return () => {
      setDeviceDetailLoaderVisibility(dispatch, false);
    };
  }, []);

  useEffect(() => {
    if (!disableManualRefresh) return;
    const intervalId = setInterval(() => {
      setManualRefreshIntervalTime((prevTimer) => {
        if (prevTimer <= 0) {
          setDisableManualRefresh(false);
          if (intervalId) clearInterval(intervalId);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [disableManualRefresh]);

  useEffect(() => {
    if (selectedDeviceDetails) {
      animateMapToRegion();
    }
  }, [
    selectedDeviceDetails,
    freeusDeviceDetails?.longitude,
    aneltoDeviceDetails?.latitude,
    clairvoyantDeviceDetails?.longitude,
    eViewDeviceDetails?.latestLocation?.lat,
  ]);

  useEffect(() => {
    try {
      if (
        aneltoDeviceDetails &&
        Object?.keys(aneltoDeviceDetails)?.length > 0
      ) {
        checkManualRefreshButtonAccess();
        if (
          !aneltoDeviceDetails?.is_data_found ||
          aneltoDeviceDetails?.is_active_request
        ) {
          setTimeout(() => {
            getDeviceDetailManually();
          }, aneltoDeviceDetails?.next_interval_call);
        }
      }
    } catch (e) {}
  }, [aneltoDeviceDetails, deviceRefreshData]);

  useEffect(() => {
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    let timeoutId = null;
    if (
      clairvoyantDeviceDetails &&
      deviceType === "clairvoyant" &&
      Object?.keys(clairvoyantDeviceDetails)?.length <= 0 &&
      currentIndex < clairvoyantIntervals?.intervals?.length
    ) {
      timeoutId = setTimeout(() => {
        getDeviceDetailManually();
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }, clairvoyantIntervals?.intervals[currentIndex]);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [
    clairvoyantIntervals?.intervals,
    clairvoyantDeviceDetails,
    selectedDeviceDetails,
  ]);

  useEffect(() => {
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    let timeoutId = null;
    if (
      eViewInterval &&
      deviceType === "eview" &&
      eViewIntervalArray?.intervals &&
      eViewIntervalIndex < eViewIntervalArray?.intervals?.length - 1 &&
      !disableManualRefresh
    ) {
      timeoutId = setTimeout(() => {
        getDeviceProfileDetail(false);
        setEviewIntervalIndex(eViewIntervalIndex + 1);
      }, eViewIntervalArray?.intervals?.[eViewIntervalIndex]);
    } else {
      setTimeout(() => {
        setDeviceDetailLoaderVisibility(dispatch, false);
        clearEviewInterval(timeoutId);
      }, 2000);
    }
    return () => {
      clearEviewInterval(timeoutId);
    };
  }, [eViewInterval, eViewIntervalIndex, selectedDeviceDetails]);

  const clearEviewInterval = (timeoutId) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };

  useEffect(() => {
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    if (freeusDeviceDetails && deviceType === "freeus") {
      checkManualRefreshButtonAccess();
    }
  }, [freeusDeviceDetails, deviceRefreshData]);

  useEffect(() => {
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    if (clairvoyantDeviceDetails && deviceType === "clairvoyant") {
      checkManualRefreshButtonAccess();
    }
  }, [clairvoyantDeviceDetails, deviceRefreshData]);

  useEffect(() => {
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    if (eViewDeviceDetails && deviceType === "eview") {
      checkManualRefreshButtonAccess();
    }
  }, [eViewDeviceDetails, deviceRefreshData]);

  useEffect(() => {
    if (disableManualRefresh && deviceDetailLoading) {
      setDeviceDetailLoaderVisibility(dispatch, false);
    }
  }, [disableManualRefresh]);

  const onUserHelpGuide = async () => {
    try {
      const url = getStaticUrlByKey(staticUrls, "user_help_guide");
      await window.open(url, "_blank");
    } catch (e) {}
  };

  const checkManualRefreshButtonAccess = () => {
    setTimeout(
      () => {
        if (selectedDeviceDetails) {
          let deviceDetail = null;
          const deviceType = selectedDeviceDetails?.device_type?.trim();
          if (deviceType) {
            if (deviceType === "anelto") {
              deviceDetail = aneltoDeviceDetails;
            } else if (deviceType === "clairvoyant") {
              deviceDetail = clairvoyantDeviceDetails;
            } else if (deviceType === "eview") {
              deviceDetail = {
                ...eViewDeviceDetails,
                created_at: eViewDeviceDetails?.generalData?.dateTime,
              };
            } else {
              deviceDetail = freeusDeviceDetails;
            }
            const lastRequestedTime = getCalculatedLastRefreshTime(
              deviceRefreshData?.last_refresh_timestamp,
              deviceDetail?.data_timestamp
            );
            if (lastRequestedTime) {
              const manualRefreshTime = getManualRefreshTime(
                deviceType,
                aneltoIntervals,
                freeusIntervals,
                clairvoyantIntervals,
                eViewIntervalArray
              );
              const isDisable = isDisableManualRefresh(
                lastRequestedTime,
                manualRefreshTime
              );
              setDisableManualRefresh(isDisable);
              if (isDisable) {
                const diffInMin = getLastRefreshTimeInMinutes(
                  lastRequestedTime,
                  true
                );
                setManualRefreshIntervalTime(
                  (manualRefreshTime * 60) - diffInMin
                );
              } else {
                setManualRefreshIntervalTime(0);
              }
            }
          }
        }
      },
      deviceRefreshData ? 0 : 2000
    );
  };

  const getDeviceDetailManually = (isManual = false) => {
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    const payload = {
      user_device_id: selectedDeviceDetails?.user_device_id,
      medical_alert_user_id: selectedDeviceDetails?.medical_alert_user_id,
      last_interval_call:
        deviceType === "anelto"
          ? aneltoDeviceDetails?.next_interval_call || 0
          : undefined,
    };
    let params = {
      dispatch,
      payload,
      history,
      setSnackBarMessage: onApiResponse,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
    };

    if (deviceType === "anelto") {
      getAneltoDeviceDetail(params, isManual);
    } else if (deviceType === "clairvoyant") {
      callHeartBeatForClairvoyantDevice({
        ...params,
        isRepeated: isManual ? false : true,
      });
    } else if (deviceType === "eview") {
      params.payload = {
        ...params?.payload,
        ...deviceLocationPayload,
        providerDeviceId: selectedDeviceDetails?.provider_device_id,
      };
      params = {
        ...params,
        isInitialLoad: false,
      };
      setEviewInterval(false);
      setEviewIntervalIndex(0);
      updateEviewFunction(params);
      setEviewInterval(true);
    } else {
      getFreeusDeviceDetail(params);
    }
  };

  const onRefresh = () => {
    if (!isInHomDevice) {
      getDeviceProfileDetail();
    }
  };

  const animateMapToRegion = () => {
    const formattedObj = customSchemaForUI();
    const regionLatlong = {
      ...deviceLocation,
      latitude: formattedObj?.latitude ? parseFloat(formattedObj?.latitude) : 0,
      longitude: formattedObj?.longitude
        ? parseFloat(formattedObj?.longitude)
        : 0,
    };
    setDeviceLocation(regionLatlong);
  };

  const getDeviceProfileDetail = (isInitialLoad) => {
    const payload = {
      user_device_id: selectedDeviceDetails?.user_device_id,
      medical_alert_user_id: selectedDeviceDetails?.medical_alert_user_id,
      providerDeviceId: selectedDeviceDetails?.provider_device_id,
    };

    let param = {
      dispatch,
      payload,
      history,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
      isInitialLoad: isInitialLoad,
    };
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    if (deviceType === "anelto") {
      getAneltoDeviceInitialLoadData(param);
    } else if (deviceType === "clairvoyant") {
      getClairvoyantDeviceDetail(param);
    } else if (deviceType === "eview") {
      getEviewDeviceDetail(param);
    } else {
      getFreeusDeviceInitialLoadData(param);
    }
  };

  const customSchemaForUI = () => {
    let deviceDetails = null;
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    if (deviceType === "anelto") {
      deviceDetails = aneltoDeviceDetails;
    } else if (deviceType === "clairvoyant") {
      deviceDetails = {
        ...clairvoyantDeviceDetails,
        battery: clairvoyantDeviceDetails?.battery_level,
        device_sku: clairvoyantDeviceDetails?.device_id,
        steps: clairvoyantDeviceDetails?.steps_since_midnight,
      };
    } else if (deviceType === "eview") {
      deviceDetails = {
        ...eViewDeviceDetails,
        device_sku: selectedDeviceDetails?.provider_device_id,
        battery: eViewDeviceDetails?.generalData?.battery,
        is_fall_detect:
          eViewDeviceDetails?.features?.fallDownAlert ||
          eViewDeviceDetails?.generalData?.fallDownStatus,
        latitude: eViewDeviceDetails?.latestLocation?.lat,
        longitude: eViewDeviceDetails?.latestLocation?.lng,
        // created_at: eViewDeviceDetails?.generalData?.dateTime,
        signal_strength: eViewDeviceDetails?.generalData?.signal_strength || 0,
      };
    } else {
      deviceDetails = freeusDeviceDetails;
    }
    const lastRequestedTime = getCalculatedLastRefreshTime(
      deviceRefreshData?.last_refresh_timestamp,
      deviceDetails?.data_timestamp
    );
    return {
      deviceName: selectedDeviceDetails?.device_name,
      autoFallDetection: deviceDetails?.is_fall_detect === 0 ? false : true,
      deviceId: selectedDeviceDetails?.provider_device_id,
      latitude: deviceDetails?.latitude,
      longitude: deviceDetails?.longitude,
      batteryLife: deviceDetails?.battery ? deviceDetails?.battery : "0",
      stepCounter: deviceDetails?.steps ? deviceDetails?.steps : "0",
      totalSteps: selectedDeviceDetails?.step_goal,
      locateMyDeviceId: deviceDetails?.device_sku || "-",
      userDeviceId: selectedDeviceDetails?.user_device_id,
      medicalAlertUserId: deviceDetails?.medical_alert_user_id,
      lastRefreshTime: lastRequestedTime, //deviceRefreshData?.last_refresh_timestamp,
      dataTimeStamp: deviceDetails?.data_timestamp,
      signal_strength: deviceDetails?.signal_strength,
      loatName: selectedDeviceDetails?.lot_name,
      networkProvider: deviceDetails?.network_provider,
      otherData: { ...deviceDetails },
    };
  };

  const onCaregavireTracking = () => {
    setDeviceDetailLoaderVisibility(dispatch, false);
    history?.push(ROUTES_CONSTANTS.caregiverTracking, {
      isButtonDisable: disableManualRefresh,
    });
  };

  const onLocationHistory = () => {
    setDeviceDetailLoaderVisibility(dispatch, false);
    history?.push(ROUTES_CONSTANTS.location, {
      isButtonDisable: disableManualRefresh,
    });
  };

  const onTapToRing = () => {
    ringMyDevice(
      dispatch,
      {
        user_device_id: selectedDeviceDetails?.user_device_id,
        medical_alert_user_id: selectedDeviceDetails?.medical_alert_user_id,
        providerDeviceId: selectedDeviceDetails?.provider_device_id,
      },
      onApiResponse,
      setShowRingDeviceModal,
      selectedDeviceDetails?.device_type,
      userData?.isGuestUser ? "guestuser" : "accountowner",
      history
    );
  };

  const onManualRefreshClick = () => {
    if (manualRefreshLoading) {
      return;
    } else if (disableManualRefresh) {
      return;
    } else {
      getDeviceDetailManually(true);
      setTimeout(() => {
        setShowLocationModal(true);
      }, 500);
    }
  };

  const convertInLocalTimeZone = (date) => {
    return convertInRequiredTimeZone(
      date,
      selectedMedicalUser?.timezone,
      currentTimeZone
    );
  };

  return (
    <MainLayout
      text={titles?.device_profile}
      isBackHide={false}
      isSemiHeader={true}
      white={true}
      primary={true}
      loading={loading}
    >
      {/* Snackbar - always sticky below header */}
      {snackbarState?.show && (
        <div className="snackbar_sticky">
          <MessageSnackBar
            message={snackbarState?.message}
            isVisible={true}
            type={snackbarState?.type}
            autoHideDuration={snackbarState?.autoHideDuration}
            onDismiss={dismissSnackbar}
          />
        </div>
      )}

      {deviceDetailLoading ? (
        <div className="gif_loader_container">
          <img height="50px" width="50px" src={loader_gif} alt="loader" />
        </div>
      ) : null}
      <div className="dp_container">
        <RingDeviceModal
          setShow={setShowRingDeviceModal}
          show={showRingDeviceModal}
          selectedDeviceDetails={selectedDeviceDetails}
          onClick={onTapToRing}
        />
        <DeviceInfoModal
          selectedDeviceDetails={selectedDeviceDetails}
          deviceSchema={customSchemaForUI()}
          setShow={setShowDeviceInfo}
          show={showDeviceInfo}
        />
        <EditDeviceNameModal
          setShow={setShowEditDeviceModal}
          show={showEditDeviceModal}
          onCancel={() => setShowEditDeviceModal(false)}
        />
        <AddStepGoalModal
          show={showAddStepGoalModal}
          setShow={setShowAddStepGoalModal}
          currentGoal={customSchemaForUI()?.totalSteps}
        />
        <ConfirmationModal
          show={showLocationModal}
          setShow={setShowLocationModal}
          svgIcon={<IconTracking />}
          btnText={titles?.OK}
          title={titles?.location_signal}
          description={titles?.location_signal_desc}
          onClick={() => setShowLocationModal(false)}
        />
        <ChangesSavedModal
          show={showSavedSuccessModal}
          setShow={setShowSavedSuccessModal}
        />
        <InformationModal
          show={informationModal}
          setShow={setInformationModal}
          infoText={titles?.modal_texts?.device_profile_footer_help_tip}
        />
        <FrequentRequestPopup
          show={frequentRequestPopup?.isVisible}
          setShow={setFrequentRequestPopup}
          lastRefreshTime={frequentRequestPopup?.lastRefreshTime}
          deviceType={selectedDeviceDetails?.device_type?.trim()}
        />

        {/* Device Profile Card */}
        <div className="dp_device_card">
          <div className="dp_device_sub_container">
            <div className="dp_device_image_container">
              {selectedDeviceDetails?.image_url ? (
                <img
                  src={selectedDeviceDetails?.image_url}
                  alt="Device"
                  className="dp_device_image"
                />
              ) : (
                <div className="dp_device_placeholder">
                  <IconGPSDevice width="32" height="32" />
                </div>
              )}
            </div>
            <div className="dp_device_description_container">
              <h2 className="dp_device_title">
                {customSchemaForUI()?.deviceName}
              </h2>
              <p className="dp_device_subtitle">
                {`${selectedDeviceDetails?.firstname} ${selectedDeviceDetails?.lastname}`}
              </p>
              <button
                className="dp_about_device_link"
                onClick={() => setShowDeviceInfo(true)}
              >
                {titles?.about_this_device}
              </button>
            </div>
            <div className="dp_edit_button_container">
              <IconEdit
                className="dp_edit_icon"
                color="#6B6B6B"
                onClick={() => setShowEditDeviceModal(true)}
              />
            </div>
          </div>

          {!isInHomDevice && (
            <>
              <CustomButton
                text={
                  manualRefreshLoading
                    ? titles?.refreshing
                    : titles?.refresh_signal
                }
                width="100%"
                className="dp_refresh_button"
                isGrayButton={disableManualRefresh || manualRefreshLoading}
                onClick={() => onManualRefreshClick()}
              />

              {convertInLocalTimeZone(customSchemaForUI()?.lastRefreshTime) && (
                <div className="dp_last_refresh_container">
                  <p className="dp_last_refresh_text">
                    {`${titles?.last_refresh} ${convertInLocalTimeZone(
                      customSchemaForUI()?.lastRefreshTime
                    )}`}
                  </p>
                  <IconQuestion
                    className="dp_help_icon"
                    width={"16px"}
                    height={"16px"}
                    onClick={() => setInformationModal(true)}
                  />
                </div>
              )}

              {manualRefreshLoading && (
                <div className="dp_loading_container">
                  <img
                    src={refresh_loop}
                    alt="Loading"
                    className="dp_refresh_loop"
                  />
                  <p className="dp_loading_text">
                    {titles?.hang_tight_app_refreshing}
                  </p>
                </div>
              )}

              {!manualRefreshLoading && disableManualRefresh && (
                <p className="dp_refresh_warning">
                  {manualRefreshIntervalTime > 0
                    ? `Frequent requests can drain battery. You can refresh again in ${manualRefreshIntervalTime} seconds.`
                    : ""}
                </p>
              )}
            </>
          )}
        </div>

        {!isInHomDevice && (
          <>
            {/* Caregiver Tracking Card */}
            <CaregiverTrackingCard
              deviceLocation={deviceLocation}
              customSchemaForUI={customSchemaForUI()}
              onCaregavireTracking={onCaregavireTracking}
              onLocationHistory={onLocationHistory}
              selectedDeviceDetails={selectedDeviceDetails}
              selectedMedicalUser={selectedMedicalUser}
              currentTimeZone={currentTimeZone}
            />

            {/* Battery Life & Signal Strength Card */}
            <DeviceSignalCard
              type={selectedDeviceDetails?.device_type}
              deviceInfo={customSchemaForUI()}
              statusUpdateAt={
                customSchemaForUI()?.dataTimeStamp
                  ? `${
                      titles?.device_status_information
                    } ${convertInLocalTimeZone(
                      customSchemaForUI()?.dataTimeStamp
                    )}`
                  : ""
              }
              className="dp_battery_signal_card"
            />

            {/* Step Counter Card */}
            {selectedDeviceDetails?.device_type === "anelto" ||
            selectedDeviceDetails?.device_type === "eview" ? null : (
              <StepCounterCard
                customSchemaForUI={customSchemaForUI()}
                setShowAddStepGoalModal={setShowAddStepGoalModal}
                selectedMedicalUser={selectedMedicalUser}
                currentTimeZone={currentTimeZone}
              />
            )}

            {/* Locate Device Card */}
            <div className="dp_locate_device_card">
              <div className="dp_locate_header">
                <div className="dp_locate_info">
                  <h4 className="dp_step_title">{titles?.locate}</h4>
                  <p className="dp_step_status_time">
                    {customSchemaForUI()?.loatName}
                  </p>
                </div>
                <CustomButton
                  text={titles?.ring_device}
                  className="dp_ring_device_button"
                  width={"128px"}
                  onClick={() => setShowRingDeviceModal(true)}
                />
              </div>
            </div>
          </>
        )}
        {/* More Options Section */}
        <div className="dp_more_options">
          <h3 className="dp_more_options_title">{titles?.more_options}</h3>
          <div className="dp_options_list">
            {accordianButtons?.map((data, index) => (
              <div
                key={`option-${index}`}
                className="dp_option_item"
                onClick={() => {
                  setDeviceDetailLoaderVisibility(dispatch, false);
                  data?.onClick();
                }}
              >
                <span className="dp_option_text">{data?.name}</span>
                <ArrowRight width="24" height="24" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default DeviceProfile;
